import { useEffect, useRef } from 'react';
import { useKeyboardNavigationContext } from './KeyboardNavigationContext';
import { generateId } from './helpers';

/** Suspends the provider's own key handling while a nested menu (e.g. a Dropdown) is open. */
export function useSuspendNavigationWhileOpen(isOpen: boolean) {
	const { setIsNavigationSuspended } = useKeyboardNavigationContext();
	const idRef = useRef(generateId());

	useEffect(() => {
		const id = idRef.current;
		setIsNavigationSuspended(id, isOpen);

		return () => setIsNavigationSuspended(id, false);
	}, [isOpen, setIsNavigationSuspended]);
}
